module.exports = __webpack_public_path__ + "img/div3.ac258fe2.jpg";